import Vue from 'vue';
import api from '../../../services/axios';

async function getParentSuperorderChecklistActivities(superOrderId) {
  const { data } = await api.get('getActivityClientByOrder', {
    params: {
      superOrderId,
      dealerId: localStorage.getItem('dealerId'),
    },
    headers: {
      Authorization: `Bearer ${Vue.prototype.$session.get('token')}`,
    },
  });

  return data.data;
}

export default function createApiActivityRepository() {
  return {
    getParentSuperorderChecklistActivities,
  };
}
